import OpenHours from './OpenHours';
export default OpenHours;
